// extracted by mini-css-extract-plugin
export default {"pending":"accountsStyles_pending__7PccK","completed":"accountsStyles_completed__jPpq5","acccount_table":"accountsStyles_acccount_table__fWz5Z"};